<template>
  <div class="d-flex personalization__dialog">
    <v-spacer />
    <v-btn
      v-if="buttonText"
      @click="togglePersonalization()"
      class="px-4"
      color="primary"
      outlined
    >
      <Icon
        name="dostosuj_tabele"
        size="small"
        class="mr-2"
      />
      {{ buttonText }}
    </v-btn>
    <v-btn
      v-else
      @click="togglePersonalization()"
      class="mx-2"
      icon
      small
    >
      <Icon
        name="dostosuj_tabele"
        size="small"
      />
    </v-btn>
    <v-dialog
      v-model="showPersonalization"
      scrollable
      max-width="600px"
    >
      <v-card>
        <v-toolbar elevation="0">
          <v-toolbar-title>Dostosuj kolumny tabeli</v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            @click="togglePersonalization()"
          >
            <v-icon big>
              mdi-close
            </v-icon>
          </v-btn>
        </v-toolbar>
        <div class="px-6 py-6">
          Zaznacz rekordy, które chcesz wyświetlać w tabeli. Poukładaj rekordy przeciągając je na liście wedle
          preferowanej kolejności.
        </div>
        <v-card-text style="height: 500px;">
          <draggable
            :list="parameters"
            class="list-group"
            ghost-class="ghost"
          >
            <v-btn
              v-for="item in parameters"
              :key="item.id"
              v-show="item.text"
              outlined
              block
              class="pl-1 mb-4 personalization__parameter"
            >
              <v-checkbox
                v-model="item.show"
              />
              {{ item.text }}
              <v-spacer />
              <Icon
                name="drag"
                class="icon--drag"
              />
            </v-btn>
          </draggable>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            outlined="outlined"
            color="primary"
            class="ml-5 px-4 hidden-sm-and-down"
            @click="togglePersonalization()"
          >
            Anuluj
          </v-btn>
          <v-btn
            color="primary"
            dark
            class="ml-5 px-4 hidden-sm-and-down"
            @click="setPersonalization()"
          >
            Zapisz zmiany
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { readJSON } from '../../utils'

export default {
  components: {
    draggable
  },
  props: {
    tableName: {
      type: String,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      default: 'tables/setTablePersonalization'
    },
    buttonText: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    showPersonalization: false,
    parameters: []
  }),
  mounted () {
    this.parameters = readJSON(this.config.parameters)
  },
  methods: {
    togglePersonalization () {
      if (!this.showPersonalization) {
        this.parameters = readJSON(this.config.parameters)
      }
      this.showPersonalization = !this.showPersonalization
    },
    setPersonalization () {
      const { parameters, tableName, action } = this
      this.$store.dispatch(action, { parameters, tableName })
      this.togglePersonalization()
    }
  }
}
</script>
